<template>
  <v-container fluid class="px-0">

    <!-- Dialog de Filtros -->
    <v-dialog v-model="dialogFiltros" max-width="600px" persistent>
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <v-icon color="white" left>mdi-filter</v-icon>
          {{ relatorioSelecionado?.nome }}
        </v-card-title>

        <v-card-text class="py-6">
          <v-form ref="formFiltros" v-model="formValido" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select
                    :items="filiaisFiltro"
                    item-text="filial"
                    item-value="idfilial"
                    label="Filial"
                    outlined
                    dense
                    :rules="[v => Array.isArray(v) && v.length > 0 || 'Campo obrigatório']"
                    v-model="filtros.idfilial"
                    hide-details="auto"
                    multiple
                    class="single-line-selection"
                >
                  <template v-slot:selection="{ item, index }">
                    <template v-if="selectAllChecked">
                      <span v-if="index === 0">Todas</span>
                    </template>
                    <template v-else>
                      <span v-if="index === 0" class="mr-1">{{ item.filial }}</span>
                      <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ filtros.idfilial.length - 1 }})
                  </span>
                    </template>
                  </template>

                  <template #prepend-item>
                    <v-list-item
                        class="pr-0"
                        dense
                        :style="{
                      backgroundColor: selectAllChecked ? '#D0D6D9' : 'transparent'
                    }"
                    >
                      <v-list-item-action>
                        <v-checkbox v-model="selectAllChecked" @click.stop="toggleSelectAll('CHECKBOX')"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content @click="toggleSelectAll('LABEL')">
                        <label class="text-subtitle-2">Todas</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12">
                <v-select
                    v-model="tipoAgrupamento"
                    outlined
                    dense
                    label="Tipo de Agrupamento"
                    item-text="nome"
                    item-value="id"
                    :items="[
                        { id: 'geral', nome: 'Geral' },
                        { id: 'filial', nome: 'por Filial' },
                        { id: 'fornecedor', nome: 'por Fornecedor' },
                        { id: 'produto', nome: 'por Combustível' },
                    ]"
                    hide-details="auto"
                >
                </v-select>
              </v-col>

              <!-- Fornecedores -->
              <CampoCliente
                  v-model="filtros.idfornecedor"
                  label="Fornecedor"
                  :noDataMessageDefault="'Digite para buscar fornecedores'"
                  :placeholder="'Selecione um fornecedor ou deixe em branco para buscar todos'"
                  :tipo="'A,F'"
                  :cols="12"
                  :md="12"
              />

              <v-col cols="12" md="6">
                <v-menu
                    v-model="menuDataIni"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formatarData(filtros.dtini)"
                        label="Data Inicial"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        :rules="[v => !!v || 'Data inicial é obrigatória']"
                        required
                        hide-details="auto"
                    />
                  </template>
                  <v-date-picker
                      v-model="filtros.dtini"
                      @input="menuDataIni = false"
                      locale="pt-br"
                  />
                </v-menu>
              </v-col>

              <v-col cols="12" md="6">
                <v-menu
                    v-model="menuDataFim"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formatarData(filtros.dtfim)"
                        label="Data Final"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        :rules="[v => !!v || 'Data final é obrigatória']"
                        required
                        hide-details="auto"
                    />
                  </template>
                  <v-date-picker
                      v-model="filtros.dtfim"
                      @input="menuDataFim = false"
                      locale="pt-br"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer />
          <v-btn
              text
              @click="fecharDialogFiltros"
          >
            Cancelar
          </v-btn>
<!--          <v-btn-->
<!--              dark-->
<!--              color="blue darken-2"-->
<!--              :loading="carregandoDados"-->
<!--              @click="buscarDados"-->
<!--              elevation="0"-->
<!--          >-->
<!--            <v-icon left>mdi-magnify</v-icon>-->
<!--            Buscar-->
<!--          </v-btn>-->
          <v-btn
              dark
              color="blue darken-2"
              @click="exportarPDF"
          >
            <v-icon left>mdi-file-pdf-box</v-icon>
            Gerar PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card outlined>
      <v-card-title class="py-4 px-5 d-flex align-center blue darken-3 white--text">
        <v-icon color="white" left>mdi-file-chart</v-icon>
        <span>Seleção de Relatório</span>
      </v-card-title>

      <v-divider />

      <!-- Seção A - Filtros de Busca de Relatório -->
      <v-expansion-panels v-model="panelFiltros" accordion flat>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-icon left color="primary">mdi-filter-variant</v-icon>
              <span class="font-weight-medium">Filtros de Busca</span>
              <v-spacer></v-spacer>
              <v-chip
                  v-if="filtrosAtivos > 0"
                  small
                  color="primary"
                  text-color="white"
                  class="mr-2"
              >
                {{ filtrosAtivos }} filtro{{ filtrosAtivos > 1 ? 's' : '' }} ativo{{ filtrosAtivos > 1 ? 's' : '' }}
              </v-chip>
            </div>
          </v-expansion-panel-header>
          <v-divider/>
          <v-expansion-panel-content>
            <v-card-text class="pt-0">
              <v-row dense>
                <v-col cols="12" md="4">
                  <v-select
                      v-model="filtros.categoria"
                      :items="categorias"
                      label="Categoria"
                      item-text="nome"
                      item-value="id"
                      prepend-inner-icon="mdi-folder"
                      hide-details="auto"
                      clearable
                      outlined
                      dense
                      @change="filtrarRelatorios"
                  />
                </v-col>

                <v-col cols="12" md="8">
                  <v-text-field
                      v-model="buscaRelatorio"
                      label="Buscar por código ou nome do relatório"
                      hide-details="auto"
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      outlined
                      dense
                      @input="filtrarRelatorios"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-col v-if="!relatorioSelecionado && relatoriosFiltrados.length > 0 && false" class="py-0">
        <div class="d-flex align-center justify-space-between px-1">
          <v-subheader class="text-caption">
            <v-icon left small>mdi-file-document-multiple</v-icon>
            Relatórios Disponíveis ({{ relatoriosFiltrados.length }})
          </v-subheader>

          <div class="d-flex align-center">
              <span class="text-caption mr-2">
                {{ (page - 1) * itemsPerPage + 1 }}-{{ Math.min(page * itemsPerPage, relatoriosFiltrados.length) }} de {{ relatoriosFiltrados.length }}
              </span>
          </div>
        </div>
      </v-col>

      <v-card-text class="pa-0">
        <!-- Seção de Resultados da Busca -->
        <div v-if="relatoriosFiltrados.length > 0">

          <v-data-table
              :headers="headers"
              :items="relatoriosPaginados"
              :page="page"
              :items-per-page="itemsPerPage"
              hide-default-footer
              class="elevation-0"
              @click:row="selecionarRelatorio"
          >
            <template v-slot:item="{ item }">
              <tr class="relatorio-row" @click="selecionarRelatorio(item)">
                <td class="py-3">
                  <div class="d-flex align-center">
                    <v-avatar
                        size="40"
                        color="grey lighten-2"
                        class="mr-3"
                    >
                      <v-icon color="grey darken-2">{{ getCategoriaIcon(item.categoria) }}</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-medium">{{ item.nome }}</div>
                      <div class="text-caption grey--text"><strong>ID: </strong>{{ item.codigo }}</div>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <v-chip
                      small
                      color="grey lighten-3"
                      class="grey--text text--darken-2"
                  >
                    {{ item.departamento }}
                  </v-chip>
                </td>
                <td class="text-center">
                  <v-chip
                      small
                      outlined
                      color="primary"
                  >
                    {{ getCategoriaName(item.categoria) }}
                  </v-chip>
                </td>
                <td class="text-center">
                  <v-btn
                      icon
                      color="grey"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>

          <v-divider/>

          <!-- Paginação -->
          <div class="d-flex justify-center mt-4" v-if="totalPages > 1">
            <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="7"
                circle
                color="primary"
            />
          </div>
        </div>

        <!-- Mensagem quando não há relatórios -->
        <div v-else-if="relatoriosFiltrados.length === 0 && (buscaRelatorio || filtros.categoria)">
          <v-row>
            <v-col cols="12" class="text-center py-8">
              <v-icon size="64" color="grey lighten-2">mdi-file-search-outline</v-icon>
              <p class="grey--text mt-4">Nenhum relatório encontrado com os filtros aplicados</p>
              <v-btn text color="primary" @click="limparFiltros">
                <v-icon left>mdi-filter-off</v-icon>
                Limpar Filtros
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <Rel_0001 ref="rel_0001" />

    <!-- Loading Overlay -->
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" />
      <p class="mt-4">Gerando relatório...</p>
    </v-overlay>
  </v-container>
</template>

<script>

import axios from "axios";
import {mapState} from "vuex";
import Rel_0001 from './Relatorios/Rel_0001.vue'
import mixinFilial from "../../../util/mixinFilial";
import CampoCliente from "@/Components/GestaoFrota/Widgets/CampoCliente.vue";

export default {
  name: 'SistemaRelatorios',
  mixins: [mixinFilial],
  components: {CampoCliente, Rel_0001 },
  data() {
    return {
      selectAllChecked: false,
      loading: false,
      carregandoDados: false,
      formValido: false,
      menuDataIni: false,
      menuDataFim: false,
      dialogFiltros: false,
      panelFiltros: null,
      buscaRelatorio: '',
      tipoAgrupamento: 'geral',
      relatorioSelecionado: null,
      page: 1,
      itemsPerPage: 10,
      headers: [
        { text: 'Relatório', value: 'nome', sortable: false, width: '40%' },
        { text: 'Departamento', value: 'departamento', align: 'center', sortable: false, width: '20%' },
        { text: 'Categoria', value: 'categoria', align: 'center', sortable: false, width: '20%' },
        { text: 'Ações', value: 'acoes', align: 'center', sortable: false, width: '20%' }
      ],
      dadosRelatorio: [],
      filtros: {
        dtini: `${new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toISOString().slice(0, 10)}`,
        dtfim: `${new Date(new Date().getFullYear(), new Date().getMonth(), 0).toISOString().slice(0, 10)}`,
        idfilial: '',
        idfornecedor: null,
        categoria: null
      },
      categorias: [
        { id: 'operacional', nome: 'Operacional' },
        { id: 'financeiro', nome: 'Financeiro' },
      ],
      relatorios: [
        {
          id: 'fechamento-combustivel',
          codigo: '0001',
          nome: 'Fechamento de Despesas de Combustível',
          categoria: 'financeiro',
          departamento: 'Frota',
          rota: '/relatorios/fechamento-combustivel'
        },
      ],
      relatoriosFiltrados: []
    }
  },
  created() {
    this.filtrarRelatorios()
    setTimeout(() => {
      this.toggleSelectAll('LABEL')
    }, 500);
  },
  methods: {
    async exportarPDF() {
      if (!this.$refs.formFiltros.validate()) {
        return
      }

      this.loading = true
      try {
        await this.buscarDados();

        this.$refs.rel_0001.visualizarPDF(this.dadosRelatorio, 'landscape', this.tipoAgrupamento || 'geral');
      } catch (error) {
        console.error('Erro ao exportar PDF:', error)
        this.$toast?.error('Erro ao exportar PDF') ||
        alert('Erro ao exportar PDF')
      } finally {
        this.loading = false
      }
    },

    toggleSelectAll(tipo) {
      if (tipo === 'CHECKBOX') {
        if (this.selectAllChecked) {
          // Se a opção "Selecionar Todos" estiver desmarcada, selecionar todas as filiais
          this.filtros.idfilial = this.filiaisFiltro.map(item => item.idfilial);
        } else {
          // Se a opção "Selecionar Todos" estiver marcada, limpar todas as seleções
          this.filtros.idfilial = [];
        }
      } else {
        if (!this.selectAllChecked) {
          // Se a opção "Selecionar Todos" estiver desmarcada, selecionar todas as filiais
          this.filtros.idfilial = this.filiaisFiltro.map(item => item.idfilial);
        } else {
          // Se a opção "Selecionar Todos" estiver marcada, limpar todas as seleções
          this.filtros.idfilial = [];
        }
        this.selectAllChecked = !this.selectAllChecked;
      }
    },

    async buscarDados() {
      if (!this.$refs.formFiltros.validate()) {
        return
      }

      this.carregandoDados = true

      try {
        const payload = {
          idfilial: this.filtros.idfilial.join(','),
          idfornecedor: this.filtros.idfornecedor || null,
          dtini: this.filtros.dtini,
          dtfim: this.filtros.dtfim
        }

        // console.log('Enviando payload:', payload)

        const response = await axios.post(`${this.backendUrl}tms/fechamento/listar`, payload);

        this.dadosRelatorio = response.data || [];
        this.dialogFiltros = false;

      } catch (error) {
        console.error('Erro ao buscar dados:', error)
        this.$toast?.error('Erro ao buscar dados do relatório') ||
        alert('Erro ao buscar dados do relatório')
      } finally {
        this.carregandoDados = false
      }
    },

    fecharDialogFiltros() {
      this.dialogFiltros = false
      this.relatorioSelecionado = null
      this.limparFiltros()
    },

    filtrarRelatorios() {
      let relatoriosFiltrados = [...this.relatorios]

      // Filtrar por categoria
      if (this.filtros.categoria) {
        relatoriosFiltrados = relatoriosFiltrados.filter(
            rel => rel.categoria === this.filtros.categoria
        )
      }

      // Filtrar por busca (código ou nome)
      if (this.buscaRelatorio) {
        const busca = this.buscaRelatorio.toLowerCase()
        relatoriosFiltrados = relatoriosFiltrados.filter(rel =>
            rel.codigo.toLowerCase().includes(busca) ||
            rel.nome.toLowerCase().includes(busca)
        )
      }

      this.relatoriosFiltrados = relatoriosFiltrados
      // Reset da página quando filtrar
      this.page = 1
    },

    selecionarRelatorio(relatorio) {
      this.relatorioSelecionado = relatorio
      this.dialogFiltros = true;
    },

    limparFiltros() {
      this.buscaRelatorio = ''
      this.filtros.categoria = null
      this.page = 1
      this.filtrarRelatorios()
    },

    getCategoriaName(categoriaId) {
      const categoria = this.categorias.find(cat => cat.id === categoriaId)
      return categoria ? categoria.nome : categoriaId
    },

    getCategoriaIcon(categoriaId) {
      const icones = {
        'operacional': 'mdi-cog',
        'financeiro': 'mdi-currency-usd'
      }
      return icones[categoriaId] || 'mdi-file'
    },
  },


  watch: {
    'filtros.idfilial'(newValue) {
      if (newValue.length === 0 || newValue.length !== this.filiaisFiltro.length) {
        this.selectAllChecked = false;
      } else {
        this.selectAllChecked = true;
      }
    },
  },

  computed: {
    ...mapState(["backendUrl", "usuario"]),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 4 &&
              v.idfilial !== 12 &&
              v.idfilial !== 13 &&
              v.idfilial !== 25 &&
              v.idfilial !== 28 &&
              v.idfilial !== 29 &&
              v.idfilial !== 37 &&
              v.idfilial !== 42 &&
              v.idfilial !== 43
          );
        });
      } else {
        return [];
      }
    },

    relatoriosPaginados() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.relatoriosFiltrados.slice(start, end)
    },

    totalPages() {
      return Math.ceil(this.relatoriosFiltrados.length / this.itemsPerPage)
    },

    filtrosAtivos() {
      let count = 0;
      if (this.filtros.categoria) count++;
      if (this.buscaRelatorio) count++;
      return count;
    },
  },
}
</script>

<style scoped>
.relatorio-row {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.relatorio-row:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}

.v-data-table >>> tbody tr:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}

.v-data-table >>> th {
  background-color: #f5f5f5 !important;
  font-weight: 600 !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 16px 0 0 0;
}
</style>